import { z } from 'zod';

export const SLIDE_STATUSES = ['DRAFT', 'FINAL', 'FROZEN'] as const;
export const SlideStatusSchema = z.enum(SLIDE_STATUSES);
export type SlideStatus = z.infer<typeof SlideStatusSchema>;

/**
 * Legacy payloads (stored operation JSON, version snapshots, wire responses
 * from pre-status backends) carry only `isDraft`. `true` maps to DRAFT and
 * `false` to FROZEN: FINAL did not exist before the status enum, so every
 * published legacy slide is a frozen editor fragment.
 */
export function normalizeSlideStatus(input: {
  status?: SlideStatus | null;
  isDraft?: boolean | null;
}): SlideStatus {
  if (input.status) return input.status;
  return input.isDraft ? 'DRAFT' : 'FROZEN';
}
